import React, { Fragment, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/app.scss';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ReactRouterGlobalHistory } from 'react-router-global-history';

// ** Import custom components for redux**
import App from "./components/app";

//MAIN SECTIONS
import Inicio from './components/inicio/inicio';
import Perfil from './components/perfil/perfil';
import Signin from './auth/signin';
import Subida from './components/excel/subida';
import Productos from './components/productos/productos';
import Sucursales from './components/sucursales/sucursales';
import Estadisticas from './components/estadisticas/estadisticas';
import Grupo from './components/grupo/grupo';
import Articulos from './components/blog/articulos';
import NuevaNoticia from './components/editor/nueva_noticia';
import CategoriasBlog from './components/blog/categorias';
import EditorNoticia from './components/editor/editor_noticia';
import LosPrimos from './components/sitio/losprimos';
import Bolsa from './components/bolsa/bolsa'
import Buzon from './components/buzon/buzon'
import Pantografo from './components/pantografo/pantografo';
import Usuarios from './components/usuarios/usuarios';
import UsuarioForm from './components/usuarios/usuario_form';
import Clientes from './components/clientes/clientes';
import ClienteForm from './components/clientes/ClienteForm';
import PermissionRoute from './components/common/PermissionRoute';

function Root() {
    const [isAuthChecked, setIsAuthChecked] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const currentPath = `${window.location.pathname}${window.location.search}`;
    const loginPath = `${process.env.PUBLIC_URL}/login`;
    const loginRedirect = `${loginPath}?returnTo=${encodeURIComponent(currentPath)}`;

    useEffect(() => {
        const verifySession = async () => {
            try{
                const response = await fetch('/p_active', {
                    method: 'POST',
                    body: JSON.stringify({}),
                    headers: {'Content-Type': 'application/json'}
                });

                if(!response.ok){
                    throw new Error('UNAUTHORIZED');
                }

                const result = await response.json();
                setIsAuthenticated(result && result.estado === 1);
            }catch (error){
                setIsAuthenticated(false);
            }finally{
                setIsAuthChecked(true);
            }
        };

        verifySession();
    }, []);

    if(!isAuthChecked){
        return (
            <div className="App">
                <div className="loader-wrapper">
                    <div className="loader bg-white">
                        <div className="whirly-loader"> </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="App">
            <BrowserRouter basename={'/'}>
                <ReactRouterGlobalHistory />
                    <Switch>
                        <Route path={`${process.env.PUBLIC_URL}/login`} component={Signin} />
                            {isAuthenticated ?
                                <Fragment>
                                    <App>
                                        {/* dashboard menu */}
                                        <Route exact path={`${process.env.PUBLIC_URL}/inicio`} render={() => {
                                            return (<Redirect to={`${process.env.PUBLIC_URL}/productos`} />)
                                        }} />
                                        <Route path={`${process.env.PUBLIC_URL}/inicio`} component={Inicio} />
                                        <Route path={`${process.env.PUBLIC_URL}/perfil`} component={Perfil} />
                                        <Route path={`${process.env.PUBLIC_URL}/subida`} component={Subida} />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/productos`} component={Productos} permission="productos" />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/sucursales`} component={Sucursales} permission="cotizaciones" />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/estadisticas`} component={Estadisticas} permission="estadisticas" />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/grupo`} component={Grupo} permissions={['departamentos', 'subdepartamentos', 'marcas', 'niveles', 'unidades']} />
                                        <Route path={`${process.env.PUBLIC_URL}/publicaciones`} component={Articulos} />
                                        <Route path={`${process.env.PUBLIC_URL}/nuevo/publicacion`} component={NuevaNoticia} />
                                        <Route path={`${process.env.PUBLIC_URL}/editar/publicacion/:id`} component={EditorNoticia} />
                                        <Route path={`${process.env.PUBLIC_URL}/categorias`} component={CategoriasBlog} />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/sitio`} component={LosPrimos} permission="banners" />
                                        <Route path={`${process.env.PUBLIC_URL}/bolsa`} component={Bolsa} />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/buzon`} component={Buzon} permission="cotizaciones" />
                                        <Route path={`${process.env.PUBLIC_URL}/pantografo`} component={Pantografo} />
                                        <PermissionRoute exact path={`${process.env.PUBLIC_URL}/usuarios`} component={Usuarios} permission="usuarios" />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/usuarios/nuevo`} component={UsuarioForm} permission="usuarios" />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/usuarios/editar/:id`} component={UsuarioForm} permission="usuarios" />
                                        <PermissionRoute exact path={`${process.env.PUBLIC_URL}/clientes`} component={Clientes} permission="clientes" />
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/clientes/nuevo`} component={ClienteForm} permission="clientes" /> 
                                        <PermissionRoute path={`${process.env.PUBLIC_URL}/clientes/editar/:id`} component={ClienteForm} permission="clientes" />
                                    </App>
                                </Fragment>
                                :
                                <Redirect to={loginRedirect} />
                            }
                    </Switch>
            </BrowserRouter>
        </div>
    );
}

ReactDOM.render(<Root />, document.getElementById('root'));
